import { t } from "i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";

const Footer = () => {
  const socialLinks = [
    {
      icon: faFacebookF,
      link: "https://www.facebook.com/green.field.company1/",
    },
  ];

  const quickLinks = [
    t("about_us_link"),
    t("contact_us_link"),
    t("our_services"),
  ];

  const businessHours = [
    { day: t("saturday_thursday"), time: t("time_8_6") },
    { day: t("friday"), time: t("closed") },
  ];

  return (
    <div
      className="container-fluid bg-dark footer mt-5 py-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("our_office")}</h4>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-primary me-fa"
              />
              {t("location_text")}
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faPhoneAlt}
                className="text-primary me-fa"
              />
              <bdo className="p-ltr">+218 91 3804049</bdo>
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faPhoneAlt}
                className="text-primary me-fa"
              />
              <bdo className="p-ltr">+218 91 0200600</bdo>
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faMapMarkerAlt}
                className="text-primary me-fa"
              />
              {t("location_text2")}
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faPhoneAlt}
                className="text-primary me-fa"
              />
              <bdo className="p-ltr">+218 91 0914049</bdo>
            </p>
            <p className="mb-2">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-primary me-fa"
              />
              info@alrawabit.com.ly
            </p>
            <div className="d-flex pt-3">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  className="btn btn-square btn-primary rounded-circle me-2"
                  href={social.link}
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("quick_links")}</h4>
            {quickLinks.map((link, index) => (
              <a key={index} className="btn btn-link" href="/">
                {link}
              </a>
            ))}
          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-primary mb-4">{t("business_hours")}</h4>
            {businessHours.map((hour, index) => (
              <div key={index}>
                <p className="mb-1">{hour.day}</p>
                <h6 className="text-light">{hour.time}</h6>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
